import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, model, signal } from '@angular/core';
import { InputComponent } from '@softline/ui-core';
import { Bookmark, LastSearchBookmarkBody } from '../../models/bookmark';

@Component({
  selector: 'soft-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  imports: [InputComponent, DatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchBarComponent {
  readonly lastSearchResults = input.required<Bookmark<LastSearchBookmarkBody>[]>();

  readonly searchFn = input.required<(searchTerm: string) => void>();

  readonly deleteAllFn = input.required<() => void>();

  readonly value = model<string>();

  readonly _value = signal<string>(this.value() ?? '');

  readonly searchFocused = signal(false);

  readonly sortedLastSearchResults = computed(() =>
    this.lastSearchResults()?.sort(
      (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    )
  );

  // TODO: add debounce
  readonly search = (): void => {
    const searchInputValue = this._value();
    if (!searchInputValue) return;
    this.searchFn()?.(searchInputValue);
    this.value.set(searchInputValue);
  };
}
